module.exports = __webpack_public_path__ + "img/adjani-2024.778aa02d.jpg";